var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.354027 9.86992C-0.0668087 10.2395 -0.120975 10.8883 0.23736 11.3223C0.595695 11.7563 1.22486 11.8121 1.6457 11.4426L2.66654 10.5488V18.5625C2.66654 20.4617 4.15821 22 5.99989 22H18C19.8408 22 21.3333 20.4617 21.3333 18.5625V10.5488L22.3529 11.4426C22.7742 11.8121 23.405 11.7563 23.7625 11.3223C24.1198 10.8883 24.0681 10.2395 23.647 9.86992L12.6458 0.244922C12.2749 -0.0816406 11.7249 -0.0816406 11.3541 0.244922L0.354027 9.86992ZM18 19.9375H16V13.4062C16 12.4566 15.2541 11.6875 14.3333 11.6875H9.66658C8.74574 11.6875 7.9999 12.4566 7.9999 13.4062V19.9375H5.99989C5.26239 19.9375 4.66655 19.323 4.66655 18.5625V8.8L11.9999 2.38348L19.3333 8.8V18.5625C19.3333 19.323 18.7375 19.9375 18 19.9375ZM13.9999 19.9375H9.99992V13.75H13.9999V19.9375Z",
    fill: "#3ECF8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.0d09ed81902a82056126ce6c1a6b6462.svg";
export { ForwardRef as ReactComponent };